export default __webpack_public_path__ + "static/media/VL_fav_white.815958d1.PNG";